module.exports = __webpack_public_path__ + "static/media/proj1_img7.dde9ac61.jpg";